/* ── Klaviyo Reviews: Show more / Show less ── */
(function () {
  function initKlaviyoShowMore() {
    var reviews = document.querySelectorAll('.kl_reviews__review__content:not([data-kl-clamped])');
    if (!reviews.length) return;

    reviews.forEach(function (el) {
      el.setAttribute('data-kl-clamped', '1');

      /* Wait for CSS clamp to apply, then measure */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          /* Only add button if content was actually truncated */
          if (el.scrollHeight <= el.clientHeight + 2) return;

          /* Wrap the <p> in a relative container */
          var wrapper = document.createElement('div');
          wrapper.className = 'kl_reviews__show-more-wrap';
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kl_reviews__show-more';
          btn.textContent = 'Show more';

          btn.addEventListener('click', function () {
            var isExpanded = el.classList.contains('is-expanded');
            if (isExpanded) {
              el.classList.remove('is-expanded');
              btn.textContent = 'Show more';
            } else {
              el.classList.add('is-expanded');
              btn.textContent = 'Show less';
            }
          });

          wrapper.appendChild(btn);
        });
      });
    });
  }

  /* Klaviyo renders dynamically — observe with debounce */
  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initKlaviyoShowMore, 200);
  });

  function start() {
    /* Try to scope observer to Klaviyo container only */
    var klaviyoContainer = document.querySelector('.klaviyo-reviews, [id*="klaviyo"], [class*="kl_reviews"]');
    if (klaviyoContainer) {
      initKlaviyoShowMore();
      observer.observe(klaviyoContainer, { childList: true, subtree: true });
    } else {
      /* Klaviyo not yet in DOM — watch body briefly, then narrow scope */
      observer.observe(document.body, { childList: true, subtree: true });
      var attempts = 0;
      var interval = setInterval(function () {
        var container = document.querySelector('.klaviyo-reviews, [id*="klaviyo"], [class*="kl_reviews"]');
        if (container) {
          observer.disconnect();
          initKlaviyoShowMore();
          observer.observe(container, { childList: true, subtree: true });
          clearInterval(interval);
        }
        attempts++;
        if (attempts >= 5) clearInterval(interval);
      }, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
